import Swiper from "swiper";
import { Pagination, Autoplay, Navigation } from "swiper/modules";

const postsCommunityCarousels = document.querySelectorAll(".posts-community-carousel");

postsCommunityCarousels.forEach(carousel => {
    const swiperHolderEl = carousel.querySelector(".swiper-holder");
    const swiperPaginationEl = carousel.querySelector(".swiper-pagination");
    const swiperEl = swiperHolderEl.querySelector(".swiper");
    const nextEl = swiperHolderEl.querySelector(".next");
    const prevEl = swiperHolderEl.querySelector(".prev");

    const swiper = new Swiper(swiperEl, {
        modules: [Pagination, Autoplay, Navigation],
        watchOverflow: true,
        slidesPerView: 'auto',
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        breakpoints: {
            1024: {
                slidesOffsetBefore: 36,
                slidesOffsetAfter: 36
            },
            1440: {
                slidesOffsetBefore: 70,
                slidesOffsetAfter: 70
            },
        },
        spaceBetween: 20,
        pagination: {
            el: swiperPaginationEl,
            type: "progressbar",
            clickable: true,
        },
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
        autoplay: false,
        pauseOnMouseEnter: true,
        on: {
            init(sw) {
                if (this.slides.length === 1) {
                    swiperPaginationEl.style.display = "none";
                    nextEl.style.display = "none";
                    prevEl.style.display = "none";
                } else {
                    let currentIndexCalc = Math.ceil(parseFloat(window.getComputedStyle(carousel.querySelector('.swiper-pagination-progressbar-fill')).transform.replace("matrix(", "").split(",")[0]) * sw.slides.length);
                    if(currentIndexCalc) {
                        carousel.querySelector(".swiper-counter").innerHTML = currentIndexCalc + " / " + sw.slides.length;
                    } else {
                        carousel.querySelector(".swiper-counter").innerHTML = (sw.activeIndex + 1) + " / " + sw.slides.length;
                    }
                }
            },
            slideChangeTransitionEnd: function (sw) {
                let currentIndexCalc = Math.ceil(parseFloat(window.getComputedStyle(carousel.querySelector('.swiper-pagination-progressbar-fill')).transform.replace("matrix(", "").split(",")[0]) * sw.slides.length);
                if(currentIndexCalc) {
                    carousel.querySelector(".swiper-counter").innerHTML = currentIndexCalc + " / " + sw.slides.length;
                } else {
                    carousel.querySelector(".swiper-counter").innerHTML = (sw.activeIndex + 1) + " / " + sw.slides.length;
                }
            }
        },
    });
});
